import { Box, Grid, Typography, Fab, Tooltip, useTheme } from '@mui/material'
import { useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { ColorModeContext } from '../../themes/themes'
import LightModeIcon from '@mui/icons-material/LightMode'
import DarkModeIcon from '@mui/icons-material/DarkMode'

const RecoverPassworOKdScreen = () => {
    const {email} = useParams();
    const navigate = useNavigate();
    const theme = useTheme();
    const colorMode = useContext(ColorModeContext);
    const isDarkMode = theme.palette.mode === 'dark';

    if(!email){
        navigate('/login')
    }
    return (
        <Box 
            sx={{
                minHeight: '100vh', 
                width: '100%', 
                background: isDarkMode 
                    ? 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)'
                    : '#fff',
                padding: { xs: 3, md: 6, lg: 8 },
                paddingTop: { xs: 4, md: 5, lg: 6 },
                transition: 'background 0.3s ease-in-out'
            }}
        >
            {/* FAB para cambiar tema */}
            <Tooltip title={isDarkMode ? "Cambiar a modo claro" : "Cambiar a modo oscuro"} placement="left">
                <Fab
                    color="primary"
                    aria-label="toggle theme"
                    onClick={colorMode.toggleColorMode}
                    sx={{
                        position: 'fixed',
                        bottom: 24,
                        right: 24,
                        zIndex: 1000,
                        background: isDarkMode 
                            ? 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)'
                            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: isDarkMode ? '#333' : '#fff',
                        boxShadow: isDarkMode 
                            ? '0 4px 20px rgba(252, 182, 159, 0.5)'
                            : '0 4px 20px rgba(102, 126, 234, 0.5)',
                        transition: 'all 0.3s ease-in-out',
                        '&:hover': {
                            transform: 'scale(1.1) rotate(15deg)',
                            background: isDarkMode 
                                ? 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)'
                                : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            boxShadow: isDarkMode 
                                ? '0 6px 25px rgba(252, 182, 159, 0.7)'
                                : '0 6px 25px rgba(102, 126, 234, 0.7)',
                        }
                    }}
                >
                    {isDarkMode ? <LightModeIcon /> : <DarkModeIcon />}
                </Fab>
            </Tooltip>

            <img 
                src={isDarkMode ? '/img/Zeta-white.png' : '/img/Zeta-black.png'} 
                alt="Zeta Logo"
                style={{
                    height: 80,
                    width: 170,
                    filter: isDarkMode 
                        ? 'drop-shadow(0 2px 10px rgba(255, 255, 255, 0.1))'
                        : 'none'
                }} 
            />
            <Grid container sx={{ mt: 2 }}>
                <Grid item xs={12} md={8} lg={6} xl={5} sx={{display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
                    <img 
                        src='/img/recoverPasswordOK.png' 
                        alt="Recovery Success"
                        style={{
                            width: 350, 
                            height: 350,
                            filter: isDarkMode ? 'brightness(0.9)' : 'none'
                        }} 
                    />
                </Grid>
                <Grid item xs={12} md={4} lg={6} xl={7} sx={{display: 'flex',justifyContent: 'center', alignItems: 'center',flexDirection: 'column'}}>
                    <Typography 
                        sx={{
                            color: isDarkMode ? '#fff' : '#000',
                            fontWeight: 'bold',
                            textAlign: { xs: 'center', md: 'left' }
                        }} 
                        variant='h2'
                    >
                        ¡Link enviado!
                    </Typography>
                    <Box sx={{display: 'flex', flexDirection: 'row', marginTop: 2}}>
                        <Typography 
                            sx={{
                                color: isDarkMode ? 'rgba(255, 255, 255, 0.8)' : '#000',
                                textAlign: { xs: 'center', md: 'left' }
                            }} 
                            component='div'
                        >
                            Ya enviamos el link para restablecer la contraseña a{' '}
                            <Box 
                                fontWeight='bold' 
                                display='inline'
                                sx={{ color: isDarkMode ? '#64B5F6' : '#0364FF' }}
                            >
                                {email}
                            </Box>
                            , revisa tus email y segui las instrucciones
                        </Typography>
                    </Box>
                    <Typography
                        sx={{
                            color: isDarkMode ? 'rgba(255, 255, 255, 0.6)' : 'gray',
                            marginTop: 2,
                            cursor: 'pointer',
                            transition: 'color 0.2s ease',
                            '&:hover': {
                                color: isDarkMode ? '#64B5F6' : '#0364FF'
                            }
                        }}
                        onClick={()=>navigate('/login')}
                    >
                        Volver al inicio de sesión
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

export default RecoverPassworOKdScreen